var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 11.319,
    viewBox: "0 0 50 11.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blue_Navy",
    transform: "translate(-5.7 -5.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wise_7_",
    transform: "translate(18.142 5.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M420.493,10.648A4.711,4.711,0,0,0,415.632,5.7c-3.612,0-6.032,2.624-6.032,6.371a4.728,4.728,0,0,0,4.928,4.948,5.448,5.448,0,0,0,5.383-3.292H417a2.532,2.532,0,0,1-2.217,1.026,2.478,2.478,0,0,1-2.6-2.479h8.153A8.057,8.057,0,0,0,420.493,10.648Zm-8.095-.339a3.136,3.136,0,0,1,3.127-2.4,2.314,2.314,0,0,1,2.382,2.4Z",
    transform: "translate(-382.935 -5.7)",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M328.7,19.04l.523-2.789c1.6.32,1.84-.581,2.256-2.75l.2-1.075c.581-3.031,1.753-4.541,5.1-4.134l-.523,2.789c-1.6-.32-1.878.891-2.237,2.769l-.2,1.075C333.241,17.994,332.031,19.446,328.7,19.04Z",
    transform: "translate(-309.868 -7.982)",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M288.3,19.206,290.275,8.4h2.6l-1.966,10.806Z",
    transform: "translate(-273.379 -8.139)",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M134.2,8.4h2.527l.823,7.814L140.861,8.4h2.508l.881,7.891,3.2-7.891h2.517l-4.58,10.806h-2.866l-.93-7.436-3.166,7.436h-2.769Z",
    transform: "translate(-134.2 -8.139)",
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "FF_7_",
    d: "M8.7,11.266l-3,2.866h5.1l.533-1.249H8.75l1.617-1.617L9.428,9.649h4.386L9.767,19.206h1.52L15.867,8.4H7.017Z",
    transform: "translate(0 -2.439)",
    fill: "currentcolor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWise);
export default __webpack_public_path__ + "static/media/wise.4c60c0d1cd094a6d3bef1b59a63ad390.svg";
export { ForwardRef as ReactComponent };